import { useState, useEffect } from 'react';
import { webSocketService } from '../services/websocket';
export const useSubscription = (room) => {
    // Initialize from cache if available
    const [data, setData] = useState(() => {
        if (!room)
            return null;
        const cached = webSocketService.getCachedData(room);
        return cached ? cached.message.data : null;
    });
    const [isLoading, setIsLoading] = useState(!!room && !data); // Only loading if room exists and no cached data
    useEffect(() => {
        // If no room, don't subscribe and clear data
        if (!room) {
            setData(null);
            setIsLoading(false);
            return;
        }
        // No need to check cache here - already done in useState initializer
        // Just subscribe for updates
        const callback = (newData) => {
            setData(newData);
            setIsLoading(false); // Hide loading when any data arrives (cached or fresh)
        };
        webSocketService.subscribe(room, callback);
        return () => {
            webSocketService.unsubscribe(room, callback);
        };
    }, [room]);
    useEffect(() => {
        const unsubscribe = webSocketService.onConnectionStatusChange(() => {
            const connectionStatus = webSocketService.getConnectionStatus();
            if (connectionStatus === 'connecting' && !data) {
                setIsLoading(true);
            }
            else if (connectionStatus === 'disconnected' && data) {
                setIsLoading(false);
            }
        });
        return unsubscribe;
    }, [data]);
    return {
        data,
        isLoading,
    };
};
